import DecimalInput from 'components/DecimalInput';
import SupplierAutosuggest from 'components/SupplierAutosuggest';
import { ISelectedMappingForEdit } from 'interfaces/supplierInventoryMapping';
import React, { useEffect, useState } from 'react';
import { createSupplierInventoryMapping, updateSupplierInventoryMapping } from 'services/api/suppliers';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';

const AddSupplierModal = props => {
  const [selectedSupplierId, setSelectedSupplierId] = useState<string>('');
  const [supplier, setSupplier] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [supplierSelected, setSupplierSelected] = useState<boolean>(false);
  const [supplierUnit, setSupplierUnit] = useState<string>('');
  const [cost, setCost] = useState<number>();
  const { isEdit, itemId, onSuccess, toggleModal, selectedSupplierMapping } = props;
  const { id, originalSupplierCost, originalSupplierUnit, supplierName }: ISelectedMappingForEdit = props.selectedSupplierMapping;

  useEffect(() => {
    if (!!Object.keys(selectedSupplierMapping).length) {
      setSupplier(selectedSupplierMapping);
      setSupplierUnit(originalSupplierUnit);
      setCost(originalSupplierCost);
    }
  }, []);

  const addSupplier = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      supplierId: selectedSupplierId,
      inventoryItemId: itemId,
      supplierUnit,
      cost,
    };
    try {
      await createSupplierInventoryMapping(data);
      await onSuccess();
      showSuccess('Supplier added successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const updateSupplier = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    const data = {
      id,
      supplierUnit,
      cost,
    };
    try {
      await updateSupplierInventoryMapping(data);
      await onSuccess();
      showSuccess('Supplier updated successfully');
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = e => {
    if (isEdit) {
      updateSupplier(e);
    } else {
      addSupplier(e);
    }
  };
  
  const SupplierDetails = () => (
    <div className={styles['supplier-details']}>
      <div className={styles['supplier-name-section']}>
        <div className={styles['label']}>Supplier Name</div>
        <div className={styles['supplier-name']}>{supplier.full_name}</div>
        <div className={styles['supplier-address']}>{supplier.address || ''}</div>
      </div>
      <div className={styles['supplier-phone-section']}>
        <div className={styles['label']}>Phone Number</div>
        <div className={styles['supplier-phone']}>{supplier.phone || 'N/A'}</div>
      </div>
      <div className={styles['supplier-email-section']}>
        <div className={styles['label']}>Email</div>
        <div className={styles['supplier-email']}>{supplier.email || 'N/A'}</div>
      </div>
    </div>
  );

  const handleCostChange = (value: number) => {
    if (!value) {
      setCost(0);
    } else {
      setCost(value);
    }
  };

  const handleSupplierSelect = (suggestion: Record<string, any>) => {
    setSupplier(suggestion);
    setSupplierSelected(true);
  };

  return (
    <form onSubmit={handleSubmit} className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Supplier</div>
            <div className={styles['modal-title']}>
              {`${isEdit ? 'Update' : 'Add a New'} Supplier`}
            </div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={'mb-3'}>
            <div className={styles['label']}>Supplier</div>
            {isEdit ? (
              <input className={'form-control'} defaultValue={`${supplierName}`} disabled={true} />
            ): (
              <SupplierAutosuggest
                supplierName={supplier.full_name || ''}
                // eslint-disable-next-line @typescript-eslint/camelcase
                setSupplierName={val => setSupplier({ ...supplier, full_name: val  })}
                setSupplier={handleSupplierSelect}
                setSupplierId={setSelectedSupplierId}
              />
            )}
          </div>
          <div className={'mb-3'}>
            <div className={styles['label']}>Unit Mapping</div>
            <input
              className={'form-control'}
              disabled={loading}
              value={supplierUnit}
              onChange={e => setSupplierUnit(e.target.value)}
            />
          </div>
          <div className={'mb-3'}>
            <div className={styles['label']}>Cost</div>
            <DecimalInput
              value={cost}
              disabled={loading}
              onChange={handleCostChange}
            />
          </div>
          {supplierSelected && <SupplierDetails />}
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type={'submit'}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </form>
  );
};

export default AddSupplierModal;
